module.exports = __webpack_public_path__ + "static/media/partnership-icon.a64d20d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/partnership-icon.svg
// module id = 3258
// module chunks = 0